import store from "../store";
import { validateLogin } from "store/slices/authSlice";

let refreshTimer = null;

export const scheduleTokenRefresh = () => {
  const { expiresAt } = store.getState().auth;

  if (!expiresAt) return;

  const now = Date.now();
  const refreshTime = expiresAt - now - 60000; // 1 minute before expiry
  const delay = Math.max(refreshTime, 0);

  // Clear previous interval before starting a new one
  if (refreshTimer) {
    clearInterval(refreshTimer);
    refreshTimer = null;
  }

  // Start interval EXACTLY at delay time
  refreshTimer = setInterval(async () => {
    const result = await store.dispatch(validateLogin());

    if (result?.meta?.requestStatus === "fulfilled") {
      // Token refreshed → reschedule new timer based on updated expiresAt
      scheduleTokenRefresh();
    } else {
      console.warn("Token refresh failed → consider logging out");
    }
  }, delay);
};
